import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../components/Home.vue';
import Details from '../components/Details';
import Login from '../components/Login';
import Register from '../components/Register';
import goTo from 'vuetify/es5/services/goto';
import firebase from 'firebase';
import Authors from '../components/Authors';

Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    redirect: '/login'
  },
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: '/stories',
    name: 'home',
    component: Home,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/authors',
    name: 'authors',
    component: Authors,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/detail',
    name: 'detail',
    props:true,
    component: Details,
    meta: {
      requiresAuth: true
    }
  }
];

const scrollBehavior = (to, from, savedPosition) => {
  let scrollTo = 0;
  if (to.hash) {
    scrollTo = to.hash
  } else if (savedPosition) {
    scrollTo = savedPosition.y
  }
  return goTo(scrollTo)
};



let router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior
});

router.beforeEach((to, from, next) => {
  let currentUser = firebase.auth().currentUser
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !currentUser) next('login')
  else if (!requiresAuth && currentUser) next('home')
  else next()
});

export default router;
